import { Grid } from "@mui/material"
import InvoicePage from "./layout/InvoicePage"
import InvoiceInfo from "./layout/InvoiceInfo"

interface IProps {
  resource: "invoices" | "drafts" | "reverseInvoices" | "invoiceReminders"
  isPreview: boolean
}

const InvoiceLayout = ({resource, isPreview}: IProps) => {

  return (
    <Grid container p={5} spacing={6} >
      <Grid item >
        <InvoicePage resource={resource} isPreview={isPreview} />
      </Grid>
      <Grid item xs>
        <InvoiceInfo resource={resource} isPreview={isPreview} />
      </Grid>
    </Grid>   
  )
}

export default InvoiceLayout